import { Box, TextField, useMediaQuery, useTheme } from '@mui/material'
import { galeriasType, UbiGaleria } from '../../types'
import { EstructuraDTO } from '../../../../dto/LocalDTO'

interface FormEstructurasProps {
  galeria: galeriasType
  ubicacionEnGaleria: UbiGaleria[]
  setUbicacionEnGaleria: (dim: UbiGaleria[]) => void
  loading: boolean
  errores: ErrorEstructura[]
  setErrores: (e: ErrorEstructura[]) => void
  disabled?: boolean
}

export interface ErrorEstructura {
  idGaleriaEstructuraDimension: number
  mensaje: string
}

const FormEstructuras = ({
  galeria,
  ubicacionEnGaleria,
  setUbicacionEnGaleria,
  loading,
  errores,
  setErrores,
  disabled
}: FormEstructurasProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const handleUbicacionChange = (dim: EstructuraDTO, valor: string) => {
    const existe = ubicacionEnGaleria?.find(
      (u: UbiGaleria) => u.idGaleriaEstructuraDimension === dim.idGaleriaEstructuraDimension
    )
    if (existe) {
      setUbicacionEnGaleria(
        ubicacionEnGaleria?.map((u) =>
          u.idGaleriaEstructuraDimension === dim.idGaleriaEstructuraDimension ? { ...u, valor } : u
        )
      )
    } else {
      setUbicacionEnGaleria([
        ...ubicacionEnGaleria,
        { idGaleriaEstructuraDimension: dim.idGaleriaEstructuraDimension, valor }
      ])
    }

    // Limpieza puntual: si este campo ya tenía un error mostrado y ahora hay contenido, lo sacamos.
    // No revalida nada más — solo saca el error de ESTE campo si corresponde.
    const tieneError = errores?.some((e) => e.idGaleriaEstructuraDimension === dim.idGaleriaEstructuraDimension)
    if (tieneError && valor.trim()) {
      setErrores(errores.filter((e) => e.idGaleriaEstructuraDimension !== dim.idGaleriaEstructuraDimension))
    }
  }

  return (
    <Box
      sx={{
        marginTop: '1rem',
        display: 'grid',
        gap: '1.5rem',
        gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr'
      }}
    >
      {galeria.estructura?.map((dim: EstructuraDTO) => {
        const valorUbicacion = ubicacionEnGaleria?.find(
          (u) => u.idGaleriaEstructuraDimension === dim.idGaleriaEstructuraDimension
        )?.valor

        const errorActual = errores?.find((e) => e.idGaleriaEstructuraDimension === dim.idGaleriaEstructuraDimension)

        return (
          <TextField
            key={dim.idGaleriaEstructuraDimension}
            value={valorUbicacion ?? dim.valor ?? dim.valorDefault ?? ''}
            placeholder={dim.descripcion}
            label={`${dim.prefijo} ${dim.nombre}`}
            error={!!errorActual}
            helperText={errorActual?.mensaje || ''}
            onChange={(e) => handleUbicacionChange(dim, e.target.value)}
            variant="outlined"
            disabled={loading || disabled}
            fullWidth
            inputProps={{ maxLength: 50 }}
          />
        )
      })}
    </Box>
  )
}

export default FormEstructuras
